



































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { Notify } from "quasar";

@Component({}) // Asegúrate de que no falten los paréntesis
export default class ConcursosPublicosComponent extends Vue {
  private concursos: any = [];
  private total: any = 0;
  private currentPage: any = 1;

  @Watch("currentPage")
  private changeCurrentPage(newValue: any) {
    if (newValue >= 0 && newValue <= Math.ceil(this.total / 9)) {
      this.getConcursos();
    }
  }

  private mounted() {
    this.getConcursos();
  }

  private getConcursos() {
    this.$q.loading.show({
      delay: 100, // ms
    });
    this.$axios
      .get("concursos?pagina=" + this.currentPage)
      .then((res: any) => {
        console.log(res);
        this.concursos = res.data.concursos;
        this.total = res.data.total;
        this.$q.loading.hide();
      })
      .catch((err: any) => {
        this.$q.loading.hide();
        console.log(err);
        if (err.response.data.message == "PAGINA_NO_EXISTE") {
          Notify.create({
            color: "negative",
            message: "No se han encontrando concursos públicos disponibles.",
            icon: "report_problem",
            position: "top",
            timeout: 2500,
          });
        }
      });
  }

  // Método para formatear a DD-MM-YYYY
  private formatearFecha(fechaRaw: string): string {
    if (!fechaRaw) return "";

    const fecha = new Date(fechaRaw);

    // Usamos padStart para asegurar que el día y mes tengan 2 dígitos
    const dia = String(fecha.getDate()).padStart(2, "0");
    const mes = String(fecha.getMonth() + 1).padStart(2, "0"); // Los meses van de 0 a 11
    const anio = fecha.getFullYear();

    return `${dia}-${mes}-${anio}`;
  }

  // Método para obtener solo el año
  private obtenerAnio(fechaRaw: string): number | string {
    if (!fechaRaw) return "";
    const fecha = new Date(fechaRaw);
    return fecha.getFullYear();
  }

  private irConcurso(nombreWeb: any) {
    if (
      this.$router.currentRoute.name == "FormularioConcursoPublico" &&
      this.$router.currentRoute.params.nombre == nombreWeb
    ) {
      this.$router.go(0);
    } else {
      this.$router
        .push({
          name: "FormularioConcursoPublico",
          params: { nombre: nombreWeb },
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
